// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cmdb-section {
  max-width: 1200px;
  margin: 0 auto;
  padding: 100px 2rem 4rem;
  min-height: 100vh;
}

.cmdb-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 2rem;
}
.cmdb-header h1 {
  font-size: 2rem;
  font-weight: 700;
  color: var(--text);
  margin: 0 0 0.4rem;
}

.cmdb-subtitle {
  color: var(--text-muted);
  font-size: 0.95rem;
  margin: 0;
}

.cmdb-refresh-btn {
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 8px;
  color: var(--text-muted);
  cursor: pointer;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  transition: color 0.2s, border-color 0.2s;
}
.cmdb-refresh-btn:hover {
  color: var(--accent);
  border-color: var(--accent);
}

.cmdb-stats-row {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
  margin-bottom: 2rem;
}

.cmdb-stat-box {
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-top: 3px solid var(--border);
  border-radius: 10px;
  padding: 0.75rem 1.25rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 90px;
  flex: 1 1;
  transition: transform 0.2s;
}
.cmdb-stat-box:hover {
  transform: translateY(-2px);
}

.cmdb-stat-value {
  font-size: 1.75rem;
  font-weight: 700;
  color: var(--text);
  line-height: 1;
}

.cmdb-stat-label {
  font-size: 0.7rem;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-top: 0.3rem;
}

.cmdb-filters {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem 1rem;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 0.75rem 1rem;
  margin-bottom: 1.5rem;
}

.cmdb-filter-group {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
}

.cmdb-filter-btn {
  background: transparent;
  border: 1px solid var(--border);
  border-radius: 6px;
  color: var(--text-muted);
  cursor: pointer;
  font-size: 0.78rem;
  padding: 0.3rem 0.7rem;
  transition: all 0.15s;
  font-family: inherit;
}
.cmdb-filter-btn:hover {
  border-color: var(--accent);
  color: var(--accent);
}
.cmdb-filter-btn.active {
  background: var(--accent);
  border-color: var(--accent);
  color: #fff;
  font-weight: 600;
}
.cmdb-filter-btn.cmdb-filter-btn--up.active {
  background: #34d399;
  border-color: #34d399;
}
.cmdb-filter-btn.cmdb-filter-btn--down.active {
  background: #ef4444;
  border-color: #ef4444;
}
.cmdb-filter-btn.cmdb-filter-btn--maintenance.active {
  background: #f59e0b;
  border-color: #f59e0b;
}

.cmdb-filter-select {
  background: var(--bg-surface);
  border: 1px solid var(--border);
  border-radius: 6px;
  color: var(--text);
  font-size: 0.78rem;
  padding: 0.3rem 0.6rem;
  cursor: pointer;
  font-family: inherit;
  outline: none;
  margin-left: auto;
}
.cmdb-filter-select:focus {
  border-color: var(--accent);
}

.cmdb-count {
  font-size: 0.8rem;
  color: var(--text-muted);
  margin: 0 0 1rem;
}

.cmdb-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 1rem;
}

.cmdb-card {
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 1.25rem;
  transition: transform 0.2s, box-shadow 0.2s, border-color 0.2s;
}
.cmdb-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
  border-color: var(--accent-soft);
}
.cmdb-card--down {
  border-left: 3px solid #ef4444;
}
.cmdb-card--maintenance {
  border-left: 3px solid #f59e0b;
}
.cmdb-card--up {
  border-left: 3px solid #34d399;
}
.cmdb-card--unknown {
  border-left: 3px solid var(--border);
}
.cmdb-card--skeleton {
  min-height: 160px;
  animation: skeleton-pulse 1.4s ease-in-out infinite;
}

@keyframes skeleton-pulse {
  0%, 100% {
    opacity: 0.6;
  }
  50% {
    opacity: 1;
  }
}
.cmdb-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.75rem;
}

.cmdb-card-type {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  color: var(--text-muted);
  font-size: 0.78rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.cmdb-status {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.06em;
}
.cmdb-status--up {
  color: #34d399;
}
.cmdb-status--down {
  color: #ef4444;
}
.cmdb-status--maintenance {
  color: #f59e0b;
}
.cmdb-status--unknown {
  color: var(--text-muted);
}

.cmdb-status-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: currentColor;
}
.cmdb-status--up .cmdb-status-dot {
  animation: pulse-green 2s infinite;
}

@keyframes pulse-green {
  0%, 100% {
    box-shadow: 0 0 0 0 rgba(52, 211, 153, 0.4);
  }
  50% {
    box-shadow: 0 0 0 4px rgba(52, 211, 153, 0);
  }
}
.cmdb-card-name {
  font-size: 1rem;
  font-weight: 600;
  color: var(--text);
  margin: 0 0 0.5rem;
  font-family: "JetBrains Mono", "Fira Code", monospace;
}

.cmdb-card-desc {
  font-size: 0.82rem;
  color: var(--text-muted);
  margin: 0 0 0.75rem;
  line-height: 1.5;
}

.cmdb-card-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  margin-bottom: 0.75rem;
}

.cmdb-env-badge {
  font-size: 0.72rem;
  border: 1px solid;
  border-radius: 4px;
  padding: 0.15rem 0.5rem;
  font-weight: 600;
}

.cmdb-meta-item {
  font-size: 0.72rem;
  color: var(--text-muted);
  background: var(--bg-surface);
  border: 1px solid var(--border);
  border-radius: 4px;
  padding: 0.15rem 0.5rem;
}

.cmdb-card-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.3rem;
}

.cmdb-tag {
  font-size: 0.68rem;
  background: rgba(96, 165, 250, 0.1);
  color: var(--accent);
  border: 1px solid rgba(96, 165, 250, 0.25);
  border-radius: 4px;
  padding: 0.1rem 0.45rem;
  font-weight: 500;
  font-family: "JetBrains Mono", "Fira Code", monospace;
}

.cmdb-error {
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.3);
  border-radius: 8px;
  color: #f87171;
  padding: 1rem 1.25rem;
  margin-bottom: 1.5rem;
  font-size: 0.9rem;
}

.cmdb-unavailable {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 80px 20px;
  color: var(--text-muted);
}
.cmdb-unavailable .cmdb-unavailable-icon {
  font-size: 2rem;
}
.cmdb-unavailable p {
  font-size: 1rem;
  font-weight: 500;
  margin: 0;
}

.cmdb-empty {
  text-align: center;
  color: var(--text-muted);
  padding: 3rem;
  font-size: 0.9rem;
}

@media (max-width: 600px) {
  .cmdb-section {
    padding: 80px 1rem 3rem;
  }
  .cmdb-stats-row {
    gap: 0.5rem;
  }
  .cmdb-stat-box {
    min-width: 70px;
    padding: 0.6rem 0.75rem;
  }
  .cmdb-stat-value {
    font-size: 1.4rem;
  }
  .cmdb-grid {
    grid-template-columns: 1fr;
  }
  .cmdb-filter-select {
    margin-left: 0;
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/CMDB.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,cAAA;EACA,wBAAA;EACA,iBAAA;AACF;;AAGA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,mBAAA;AAAF;AAEE;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AAAJ;;AAIA;EACE,wBAAA;EACA,kBAAA;EACA,SAAA;AADF;;AAIA;EACE,0BAAA;EACA,+BAAA;EACA,kBAAA;EACA,wBAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,yCAAA;AADF;AAGE;EACE,oBAAA;EACA,2BAAA;AADJ;;AAMA;EACE,aAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;AAHF;;AAMA;EACE,0BAAA;EACA,+BAAA;EACA,mCAAA;EACA,mBAAA;EACA,wBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;EACA,0BAAA;AAHF;AAKE;EAAU,2BAAA;AAFZ;;AAKA;EACE,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AAFF;;AAKA;EACE,iBAAA;EACA,wBAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;AAFF;;AAMA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,0BAAA;EACA,+BAAA;EACA,mBAAA;EACA,qBAAA;EACA,qBAAA;AAHF;;AAMA;EACE,aAAA;EACA,eAAA;EACA,YAAA;AAHF;;AAMA;EACE,uBAAA;EACA,+BAAA;EACA,kBAAA;EACA,wBAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,qBAAA;EACA,oBAAA;AAHF;AAKE;EACE,2BAAA;EACA,oBAAA;AAHJ;AAME;EACE,yBAAA;EACA,2BAAA;EACA,WAAA;EACA,gBAAA;AAJJ;AAOE;EAAkC,mBAAA;EAAqB,qBAAA;AAHzD;AAIE;EAAkC,mBAAA;EAAqB,qBAAA;AAAzD;AACE;EAAwC,mBAAA;EAAqB,qBAAA;AAG/D;;AAAA;EACE,6BAAA;EACA,+BAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,oBAAA;EACA,aAAA;EACA,iBAAA;AAGF;AADE;EAAU,2BAAA;AAIZ;;AAAA;EACE,iBAAA;EACA,wBAAA;EACA,gBAAA;AAGF;;AACA;EACE,aAAA;EACA,4DAAA;EACA,SAAA;AAEF;;AAEA;EACE,0BAAA;EACA,+BAAA;EACA,mBAAA;EACA,gBAAA;EACA,8DAAA;AACF;AACE;EACE,2BAAA;EACA,0CAAA;EACA,gCAAA;AACJ;AAEE;EAAa,8BAAA;AACf;AAAE;EAAiB,8BAAA;AAGnB;AAFE;EAAa,8BAAA;AAKf;AAJE;EAAa,oCAAA;AAOf;AALE;EACE,iBAAA;EACA,mDAAA;AAOJ;;AAHA;EACE;IAAW,YAAA;EAOX;EANA;IAAM,UAAA;EASN;AACF;AAPA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,sBAAA;AASF;;AANA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,wBAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;AASF;;AANA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;AASF;AAPE;EAAiB,cAAA;AAUnB;AATE;EAAiB,cAAA;AAYnB;AAXE;EAAiB,cAAA;AAcnB;AAbE;EAAiB,wBAAA;AAgBnB;;AAbA;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,wBAAA;AAgBF;AAdE;EAAqB,kCAAA;AAiBvB;;AAdA;EACE;IAAW,2CAAA;EAkBX;EAjBA;IAAM,2CAAA;EAoBN;AACF;AAlBA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qDAAA;AAoBF;;AAjBA;EACE,kBAAA;EACA,wBAAA;EACA,mBAAA;EACA,gBAAA;AAoBF;;AAjBA;EACE,aAAA;EACA,eAAA;EACA,WAAA;EACA,sBAAA;AAoBF;;AAjBA;EACE,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;EACA,gBAAA;AAoBF;;AAjBA;EACE,kBAAA;EACA,wBAAA;EACA,6BAAA;EACA,+BAAA;EACA,kBAAA;EACA,uBAAA;AAoBF;;AAhBA;EACE,aAAA;EACA,eAAA;EACA,WAAA;AAmBF;;AAhBA;EACE,kBAAA;EACA,mCAAA;EACA,oBAAA;EACA,0CAAA;EACA,kBAAA;EACA,uBAAA;EACA,gBAAA;EACA,qDAAA;AAmBF;;AAfA;EACE,kCAAA;EACA,wCAAA;EACA,kBAAA;EACA,cAAA;EACA,qBAAA;EACA,qBAAA;EACA,iBAAA;AAkBF;;AAfA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,wBAAA;AAkBF;AAhBE;EAAyB,eAAA;AAmB3B;AAjBE;EACE,eAAA;EACA,gBAAA;EACA,SAAA;AAmBJ;;AAfA;EACE,kBAAA;EACA,wBAAA;EACA,aAAA;EACA,iBAAA;AAkBF;;AAdA;EACE;IAAgB,uBAAA;EAkBhB;EAjBA;IAAkB,WAAA;EAoBlB;EAnBA;IAAiB,eAAA;IAAiB,uBAAA;EAuBlC;EAtBA;IAAmB,iBAAA;EAyBnB;EAxBA;IAAa,0BAAA;EA2Bb;EA1BA;IAAsB,cAAA;IAAgB,WAAA;EA8BtC;AACF","sourcesContent":[".cmdb-section {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 100px 2rem 4rem;\n  min-height: 100vh;\n}\n\n// Header\n.cmdb-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  margin-bottom: 2rem;\n\n  h1 {\n    font-size: 2rem;\n    font-weight: 700;\n    color: var(--text);\n    margin: 0 0 0.4rem;\n  }\n}\n\n.cmdb-subtitle {\n  color: var(--text-muted);\n  font-size: 0.95rem;\n  margin: 0;\n}\n\n.cmdb-refresh-btn {\n  background: var(--bg-card);\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  color: var(--text-muted);\n  cursor: pointer;\n  padding: 0.5rem;\n  display: flex;\n  align-items: center;\n  transition: color 0.2s, border-color 0.2s;\n\n  &:hover {\n    color: var(--accent);\n    border-color: var(--accent);\n  }\n}\n\n// Stats row\n.cmdb-stats-row {\n  display: flex;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n  margin-bottom: 2rem;\n}\n\n.cmdb-stat-box {\n  background: var(--bg-card);\n  border: 1px solid var(--border);\n  border-top: 3px solid var(--border);\n  border-radius: 10px;\n  padding: 0.75rem 1.25rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  min-width: 90px;\n  flex: 1;\n  transition: transform 0.2s;\n\n  &:hover { transform: translateY(-2px); }\n}\n\n.cmdb-stat-value {\n  font-size: 1.75rem;\n  font-weight: 700;\n  color: var(--text);\n  line-height: 1;\n}\n\n.cmdb-stat-label {\n  font-size: 0.7rem;\n  color: var(--text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin-top: 0.3rem;\n}\n\n// Filters\n.cmdb-filters {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.5rem 1rem;\n  background: var(--bg-card);\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  padding: 0.75rem 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.cmdb-filter-group {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n}\n\n.cmdb-filter-btn {\n  background: transparent;\n  border: 1px solid var(--border);\n  border-radius: 6px;\n  color: var(--text-muted);\n  cursor: pointer;\n  font-size: 0.78rem;\n  padding: 0.3rem 0.7rem;\n  transition: all 0.15s;\n  font-family: inherit;\n\n  &:hover {\n    border-color: var(--accent);\n    color: var(--accent);\n  }\n\n  &.active {\n    background: var(--accent);\n    border-color: var(--accent);\n    color: #fff;\n    font-weight: 600;\n  }\n\n  &.cmdb-filter-btn--up.active    { background: #34d399; border-color: #34d399; }\n  &.cmdb-filter-btn--down.active  { background: #ef4444; border-color: #ef4444; }\n  &.cmdb-filter-btn--maintenance.active { background: #f59e0b; border-color: #f59e0b; }\n}\n\n.cmdb-filter-select {\n  background: var(--bg-surface);\n  border: 1px solid var(--border);\n  border-radius: 6px;\n  color: var(--text);\n  font-size: 0.78rem;\n  padding: 0.3rem 0.6rem;\n  cursor: pointer;\n  font-family: inherit;\n  outline: none;\n  margin-left: auto;\n\n  &:focus { border-color: var(--accent); }\n}\n\n// Count\n.cmdb-count {\n  font-size: 0.8rem;\n  color: var(--text-muted);\n  margin: 0 0 1rem;\n}\n\n// Grid\n.cmdb-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n  gap: 1rem;\n}\n\n// Cards\n.cmdb-card {\n  background: var(--bg-card);\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  padding: 1.25rem;\n  transition: transform 0.2s, box-shadow 0.2s, border-color 0.2s;\n\n  &:hover {\n    transform: translateY(-3px);\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);\n    border-color: var(--accent-soft);\n  }\n\n  &--down    { border-left: 3px solid #ef4444; }\n  &--maintenance { border-left: 3px solid #f59e0b; }\n  &--up      { border-left: 3px solid #34d399; }\n  &--unknown { border-left: 3px solid var(--border); }\n\n  &--skeleton {\n    min-height: 160px;\n    animation: skeleton-pulse 1.4s ease-in-out infinite;\n  }\n}\n\n@keyframes skeleton-pulse {\n  0%, 100% { opacity: 0.6; }\n  50% { opacity: 1; }\n}\n\n.cmdb-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.75rem;\n}\n\n.cmdb-card-type {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  color: var(--text-muted);\n  font-size: 0.78rem;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n}\n\n.cmdb-status {\n  display: flex;\n  align-items: center;\n  gap: 0.35rem;\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n\n  &--up          { color: #34d399; }\n  &--down        { color: #ef4444; }\n  &--maintenance { color: #f59e0b; }\n  &--unknown     { color: var(--text-muted); }\n}\n\n.cmdb-status-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: currentColor;\n\n  .cmdb-status--up & { animation: pulse-green 2s infinite; }\n}\n\n@keyframes pulse-green {\n  0%, 100% { box-shadow: 0 0 0 0 rgba(52, 211, 153, 0.4); }\n  50% { box-shadow: 0 0 0 4px rgba(52, 211, 153, 0); }\n}\n\n.cmdb-card-name {\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--text);\n  margin: 0 0 0.5rem;\n  font-family: \"JetBrains Mono\", \"Fira Code\", monospace;\n}\n\n.cmdb-card-desc {\n  font-size: 0.82rem;\n  color: var(--text-muted);\n  margin: 0 0 0.75rem;\n  line-height: 1.5;\n}\n\n.cmdb-card-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n  margin-bottom: 0.75rem;\n}\n\n.cmdb-env-badge {\n  font-size: 0.72rem;\n  border: 1px solid;\n  border-radius: 4px;\n  padding: 0.15rem 0.5rem;\n  font-weight: 600;\n}\n\n.cmdb-meta-item {\n  font-size: 0.72rem;\n  color: var(--text-muted);\n  background: var(--bg-surface);\n  border: 1px solid var(--border);\n  border-radius: 4px;\n  padding: 0.15rem 0.5rem;\n}\n\n// Tags\n.cmdb-card-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.3rem;\n}\n\n.cmdb-tag {\n  font-size: 0.68rem;\n  background: rgba(96, 165, 250, 0.1);\n  color: var(--accent);\n  border: 1px solid rgba(96, 165, 250, 0.25);\n  border-radius: 4px;\n  padding: 0.1rem 0.45rem;\n  font-weight: 500;\n  font-family: \"JetBrains Mono\", \"Fira Code\", monospace;\n}\n\n// States\n.cmdb-error {\n  background: rgba(239, 68, 68, 0.1);\n  border: 1px solid rgba(239, 68, 68, 0.3);\n  border-radius: 8px;\n  color: #f87171;\n  padding: 1rem 1.25rem;\n  margin-bottom: 1.5rem;\n  font-size: 0.9rem;\n}\n\n.cmdb-unavailable {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  padding: 80px 20px;\n  color: var(--text-muted);\n\n  .cmdb-unavailable-icon { font-size: 2rem; }\n\n  p {\n    font-size: 1rem;\n    font-weight: 500;\n    margin: 0;\n  }\n}\n\n.cmdb-empty {\n  text-align: center;\n  color: var(--text-muted);\n  padding: 3rem;\n  font-size: 0.9rem;\n}\n\n// Mobile\n@media (max-width: 600px) {\n  .cmdb-section { padding: 80px 1rem 3rem; }\n  .cmdb-stats-row { gap: 0.5rem; }\n  .cmdb-stat-box { min-width: 70px; padding: 0.6rem 0.75rem; }\n  .cmdb-stat-value { font-size: 1.4rem; }\n  .cmdb-grid { grid-template-columns: 1fr; }\n  .cmdb-filter-select { margin-left: 0; width: 100%; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
